import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ContentLoaderComponent } from './content-loader/content-loader.component';

@Directive({
  selector: '[cidContentLoader]'
})
export class ContentLoaderDirective {

  loading?: boolean;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() set cidContentLoader(condition: boolean) {
    if (condition !== this.loading) {
      this.viewContainer.clear();
      this.loading = condition;
      if (!condition) {
        // Render the template
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else if (condition) {
        this.addSpinner(this.viewContainer);
      }
    }
  }

  private addSpinner(viewContainer: ViewContainerRef): void {
    const { instance } =
      viewContainer.createComponent(ContentLoaderComponent);
    instance.contentLoading = true;
  }

}
